(function () {
  'use strict';

  const popup = document.getElementById('jaido-sales-popup');
  if (!popup) return;

  const data = window.JAiDOSalesData || {};

  const settings = Object.assign({
    showAfter: 5000,
    visibleFor: 5000,
    minDelay: 6000,
    maxDelay: 9000
  }, data.settings || {});

  const nameEl = document.getElementById('jaidoCustomerName');
  const timeEl = document.getElementById('jaidoTime');
  const productTitleEl = document.getElementById('jaidoProduct');
  const productImageEl = document.getElementById('jaidoProductImage');
  const closeBtn = popup.querySelector('.jaido-close');

  // "weight" controls how often each one shows relative to the others.
  const products = [
    {
      title: 'JAiDO Sling Bag — Gray',
      image: 'https://cdn.shopify.com/s/files/1/0778/9985/8110/files/Gray_sling_backpack_displayed_2K_202609070718.jpg?v=1788748143',
      weight: 50
    },
    {
      title: 'JAiDO Sling Bag — Black',
      image: 'https://cdn.shopify.com/s/files/1/0778/9985/8110/files/Black_crossbody_sling_bag_stands_2K_202609070712.jpg?v=1788748076',
      weight: 25
    },
    {
      title: 'JAiDO Sling Bag — Blue',
      image: 'https://cdn.shopify.com/s/files/1/0778/9985/8110/files/Blue_sling_backpack_stands_upright_2K_202609070721.jpg?v=1788748142',
      weight: 15
    },
    {
      title: 'Multi Pockets Travel Bag',
      image: 'https://cdn.shopify.com/s/files/1/0778/9985/8110/files/main-01__1_.jpg_2K_202609081940.jpg?v=1788899765',
      weight: 10
    }
  ];

  function randomItem(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function weightedRandomProduct(items) {
    const totalWeight = items.reduce((sum, item) => sum + (item.weight || 1), 0);
    let roll = Math.random() * totalWeight;

    for (const item of items) {
      roll -= (item.weight || 1);
      if (roll <= 0) return item;
    }

    return items[items.length - 1];
  }

  function randomDelay() {
    return Math.floor(
      Math.random() * (settings.maxDelay - settings.minDelay + 1)
    ) + settings.minDelay;
  }

  function updatePopup() {
    const first = randomItem(data.firstNames || ['Ahmed']);
    const last = randomItem(data.lastNames || ['Khan']);
    const city = randomItem(data.cities || ['Lahore']);
    const time = randomItem(data.times || ['Just now']);
    const product = weightedRandomProduct(products);

    nameEl.textContent = `${first} ${last} (${city})`;
    timeEl.textContent = time;
    productTitleEl.textContent = product.title;

    if (product.image) {
      productImageEl.src = product.image;
    }
  }

  let timer;

  function hidePopup() {
    popup.classList.remove('show');
    popup.classList.add('hide');

    setTimeout(() => {
      popup.hidden = true;
      scheduleNext();
    }, 350);
  }

  function showPopup() {
    updatePopup();

    popup.hidden = false;

    requestAnimationFrame(() => {
      popup.classList.remove('hide');
      popup.classList.add('show');
    });

    clearTimeout(timer);
    timer = setTimeout(hidePopup, settings.visibleFor);
  }

  function scheduleNext() {
    setTimeout(showPopup, randomDelay());
  }

  closeBtn.addEventListener('click', () => {
    clearTimeout(timer);
    popup.hidden = true;
    popup.classList.remove('show');
    popup.classList.add('hide');
    scheduleNext();
  });

  setTimeout(showPopup, settings.showAfter);
})();